import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function RoutingServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1074_1983)'} = props;
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<path opacity="0.4"
			      d="M11.8399 6.13334C10.7732 1.52 3.82654 1.50667 2.75987 6.13334C2.1332 8.84 3.8532 11.1333 5.34654 12.56C6.43987 13.5867 8.15987 13.5867 9.2532 12.56C10.7465 11.1333 12.4532 8.84 11.8399 6.13334ZM7.34654 8.26667C6.6132 8.26667 6.0132 7.66667 6.0132 6.93334C6.0132 6.2 6.59987 5.6 7.3332 5.6H7.34654C8.0932 5.6 8.67987 6.2 8.67987 6.93334C8.67987 7.66667 8.0932 8.26667 7.34654 8.26667Z"
			      fill={color}/>
			<path
				d="M8.67985 6.93331C8.67985 7.66664 8.09318 8.26664 7.34652 8.26664C6.61318 8.26664 6.01318 7.66664 6.01318 6.93331C6.01318 6.19998 6.59985 5.59998 7.33318 5.59998H7.34652C8.09318 5.59998 8.67985 6.19998 8.67985 6.93331Z"
				fill={color}/>
			<path opacity="0.4"
			      d="M29.2133 22.1333C28.1467 17.52 21.1733 17.5067 20.0933 22.1333C19.4667 24.84 21.1867 27.1333 22.6933 28.56C23.7867 29.5867 25.52 29.5867 26.6133 28.56C28.12 27.1333 29.84 24.84 29.2133 22.1333ZM24.7067 24.2667C23.9733 24.2667 23.3733 23.6667 23.3733 22.9333C23.3733 22.2 23.96 21.6 24.6933 21.6H24.7067C25.44 21.6 26.04 22.2 26.04 22.9333C26.04 23.6667 25.44 24.2667 24.7067 24.2667Z"
			      fill={color}/>
			<path
				d="M26.0402 22.9333C26.0402 23.6666 25.4402 24.2666 24.7069 24.2666C23.9735 24.2666 23.3735 23.6666 23.3735 22.9333C23.3735 22.2 23.9602 21.6 24.6935 21.6H24.7069C25.4402 21.6 26.0402 22.2 26.0402 22.9333Z"
				fill={color}/>
			<path
				d="M15.9998 26.3333H12.4264C10.8798 26.3333 9.53309 25.4 8.99976 23.96C8.45309 22.52 8.85309 20.9333 10.0131 19.9066L20.6664 10.5866C21.3064 10.0266 21.3198 9.26663 21.1331 8.74663C20.9331 8.22663 20.4264 7.66663 19.5731 7.66663H15.9998C15.4531 7.66663 14.9998 7.21329 14.9998 6.66663C14.9998 6.11996 15.4531 5.66663 15.9998 5.66663H19.5731C21.1198 5.66663 22.4664 6.59996 22.9998 8.03996C23.5464 9.47996 23.1464 11.0666 21.9864 12.0933L11.3331 21.4133C10.6931 21.9733 10.6798 22.7333 10.8664 23.2533C11.0664 23.7733 11.5731 24.3333 12.4264 24.3333H15.9998C16.5464 24.3333 16.9998 24.7866 16.9998 25.3333C16.9998 25.88 16.5464 26.3333 15.9998 26.3333Z"
				fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1074_1983" x1="11.7687" y1="2.66834" x2="2.17355" y2="3.09381"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
